<template>
    <div>


        <b-container>
            <b-row>
                <b-col></b-col>
            </b-row>
            <b-row>
                <div style='margin-top:20px'><h2>Welcome To Keg Seeker</h2></div>
                
            </b-row>
            <b-row><hr></b-row>
            <b-row>
                <h5>
                    Check out the <router-link to="faq" >FAQ</router-link> page to learn more about how Keg Seeker works
                </h5>
            </b-row>
            
            <b-row>
                <h5>
                    Start by adding some beers to your inventory from the <router-link to="inventory" >INVENTORY</router-link> page
                </h5>
            </b-row>
            <b-row><hr></b-row>
            <b-row>
                <h5>
                    From the <router-link to="brewerorders" >ORDERS</router-link> page, you can accept, decline or update status of orders
                </h5>
            </b-row>
            <b-row><hr></b-row>
            
            <b-row>
                <h5>
                    Say something about your brewery, add your logo and license from the <router-link to="settings" >SETTINGS</router-link> page
                </h5>
            </b-row>
            <b-row><hr></b-row>

            


            <b-row><hr></b-row>
            <b-row>
                <b-button variant="outline-primary"><router-link to="inventory" > Continue to Inventory</router-link></b-button>
            </b-row>
            <b-row><hr></b-row>

        </b-container>
        <footer><pagefooter/></footer>
    </div>
</template>

<script>
import Pagefooter from './Pagefooter'
    export default {
        components: {
            Pagefooter,
        },
        
    }
</script>